document.addEventListener("DOMContentLoaded", () => {
    const enhanceMobileNavLinks = () => {
        const mobileNavList = document.querySelector(".mobile-nav-list");
        if (!mobileNavList) {
            return;
        }

        mobileNavList.querySelectorAll("a:not(.nav-link)").forEach((link) => link.classList.add("nav-link"));
    };
    enhanceMobileNavLinks();

    const navToggle = document.getElementById("mobile-nav-toggle");
    const navMenu = document.getElementById("mobile-nav-menu");
    const navOverlay = document.getElementById("mobile-nav-overlay");
    const closeButton = document.querySelector(".mobile-nav-close");

    const closeAllSubmenus = () => {
        navMenu
            .querySelectorAll('.submenu[aria-hidden="false"]')
            .forEach((submenu) => submenu.setAttribute("aria-hidden", "true"));

        navMenu
            .querySelectorAll('button[aria-expanded="true"]')
            .forEach((btn) => btn.setAttribute("aria-expanded", "false"));
    };

    const openMainNav = () => {
        navToggle.setAttribute("aria-expanded", "true");
        navMenu.setAttribute("aria-hidden", "false");
        document.body.classList.add("nav-open");
    };

    const closeMainNav = () => {
        navToggle.setAttribute("aria-expanded", "false");
        navMenu.setAttribute("aria-hidden", "true");
        document.body.classList.remove("nav-open");
        closeAllSubmenus();
    };

    if (navToggle) {
        navToggle.addEventListener("click", () => {
            const isExpanded = navToggle.getAttribute("aria-expanded") === "true";
            isExpanded ? closeMainNav() : openMainNav();
        });
    }

    if (closeButton) {
        closeButton.addEventListener("click", closeMainNav);
    }

    if (navOverlay) {
        navOverlay.addEventListener("click", closeMainNav);
    }

    document.addEventListener("keydown", (e) => {
        const isNavOpen = navToggle.getAttribute("aria-expanded") === "true";
        if (e.key === "Escape" && isNavOpen) {
            closeMainNav();
        }
    });

    navMenu.querySelectorAll(".submenu-toggle").forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
            e.stopPropagation();

            const submenuId = toggle.getAttribute("aria-controls");
            const submenu = document.getElementById(submenuId);
            if (!submenu) {
                return;
            }

            const parentUl = toggle.closest("ul");
            parentUl.querySelectorAll('.submenu-toggle[aria-expanded="true"]').forEach((sib) => {
                if (sib === toggle) {
                    return;
                }
                const sibSubmenu = document.getElementById(sib.getAttribute("aria-controls"));
                sib.setAttribute("aria-expanded", "false");
                if (sibSubmenu) {
                    sibSubmenu.setAttribute("aria-hidden", "true");
                }
            });

            const isExpanded = toggle.getAttribute("aria-expanded") === "true";
            toggle.setAttribute("aria-expanded", isExpanded ? "false" : "true");
            submenu.setAttribute("aria-hidden", isExpanded ? "true" : "false");
        });
    });

    navMenu.querySelectorAll(".back-button").forEach((button) => {
        button.addEventListener("click", (e) => {
            e.stopPropagation();

            const submenu = button.closest(".submenu");
            if (!submenu) {
                return;
            }

            const toggle = document.querySelector(`[aria-controls="${submenu.id}"]`);
            if (toggle) {
                toggle.setAttribute("aria-expanded", "false");
                submenu.setAttribute("aria-hidden", "true");
            }
        });
    });

    const siteSwitchButton = document.getElementById("site-switch-button");
    const siteSwitchDropdown = document.getElementById("site-switch-dropdown");
    const siteSwitcherClose = siteSwitchDropdown?.querySelector(".dropdown-close") ?? null;

    if (siteSwitchButton && siteSwitchDropdown) {
        siteSwitchButton.addEventListener("click", (e) => {
            e.stopPropagation();
            const isOpen = siteSwitchDropdown.classList.contains("show");
            siteSwitchDropdown.classList.toggle("show", !isOpen);
            siteSwitchButton.setAttribute("aria-expanded", isOpen ? "false" : "true");
        });

        if (siteSwitcherClose) {
            siteSwitcherClose.addEventListener("click", (e) => {
                e.stopPropagation();
                siteSwitchDropdown.classList.remove("show");
                siteSwitchButton.setAttribute("aria-expanded", "false");
            });
        }

        document.addEventListener("click", (e) => {
            const isClickInside = siteSwitchButton.contains(e.target) || siteSwitchDropdown.contains(e.target);
            if (!isClickInside) {
                siteSwitchDropdown.classList.remove("show");
                siteSwitchButton.setAttribute("aria-expanded", "false");
            }
        });
    }
});
